<template>
	<div class="page" data-name="payment-online-list">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">
				온라인 수강권 결제
			</div>			
			<f7-nav-right>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
			</f7-nav-right>
		</f7-navbar>
		
		<!-- 상단 툴바
		<div class="toolbar toolbar-top">
			<div class="toolbar-inner">	
				<div class="row"></div>
			
				<div class="row">
					<div class="col" style="width:auto;">		
						<label class="radio">
							<input type="radio" name="radio-addrType" value="company" v-model="radioAddrType">
							<i class="icon-radio" style="margin-right:2px;float:left"></i>
							<div class="item-inner"  style="float:left;margin-right:5px;">
								<div class="item-title" style="color:#000;">학원으로 배송</div>
							</div>
						</label>
					</div>
					<div class="col" style="width:auto">
						<label class="radio">
							<input type="radio" name="radio-addrType" value="user" v-model="radioAddrType">
							<i class="icon-radio" style="margin-right:2px;float:left"></i>
							<div class="item-inner"  style="float:left;margin-right:10px;">
								<div class="item-title" style="color:#000;">주소지로 배송</div>
							</div>
						</label>					
					</div>
				</div>			
			</div>
		</div>
 		-->
		<!--자녀별 온라인 수강 상품 리스트-->
		<div class="page-content" style="background-color:#efeff4">
			<div class="list no-hairlines-between" style="padding-bottom:15px">
				<template v-for="(item, i) in onlinePaymentList">
					<div :key="'block-'+i" class="block">
						<div class="block-header">
							<div class="item-inner">  
							<b><span style="font-size:1.6em">{{item.STUDENT_NAME}}</span> 학생 ({{getDate(item.AUTH_EXP_DATE)}}일 수강권 만료)</b>													
							<div class="item-after" v-if="i == 0">
								<button class="button button-fill" v-on:click="goBasket();">
									<span>장바구니</span>
									<span class="badge color-red no-margin" style="vertical-align:text-top" v-if="basketCnt > 0">
										{{basketCnt}}
									</span>
								</button>
							
							</div>
							</div>
						</div>
						
						<div class="row card card-outline">
							<template v-for="(subItem, j) in item.productList">								
								<div :key="'content-'+j" class="thin-border-box top-box col-100 xsmall-50 small-50 medium-33 large-33 xlarge-auto">	
									<div class="product-box">																																	
										<img :src="getProductImg(subItem)" class="actions-open" style="width:100%;height:auto;cursor:pointer" data-actions=".action-sheet-menu" v-on:click="addItem(subItem)" />																																						
										<div class="amount-box">
											<span class="original-box" v-if="subItem.DISCOUNT_PRICE > 0">
												<s>{{getPrice(subItem.ORIGINAL_PRICE)}} 원</s>
											</span>
											<span style="display:inline-block;width:3%">&nbsp;</span>
											<span class="discount-box">
												{{getPrice(subItem.ORIGINAL_PRICE-subItem.DISCOUNT_PRICE)}} 원
											</span>
										</div>
									</div>
								</div>							  	
							</template>
						</div>

					</div>
				</template>
			</div>
			
		</div>
		
		<!-- 하단 툴바 
		<div class="toolbar toolbar-bottom" style="background-color:#00aaff">
			<div class="toolbar-inner" style="padding:5px;">							
				<div class="row" style="width:100%;height:100%;">
					<div class="col"></div>  
					<div class="col">
						<i class="f7-icons" style="cursor:pointer" v-on:click="addBasket();">
							cart_fill
						</i>														
					</div>
					<div class="col">  
						<i class="f7-icons" style="cursor:pointer" v-on:click="finalPayment();">
							money_dollar_circle_fill
						</i>														
					</div>
				</div>				
			</div>
		</div> 
		--> 
		<div class="actions-modal action-sheet-menu" id="action-sheet-menu">
  		<div class="actions-group" >
				<!--
				<div class="actions-label row" style="width:100%">							
					<label class="radio col">
						<input type="radio" name="radio-addrType" value="company" v-model="radioAddrType">
						<i class="icon-radio" style="margin-right:2px;float:left"></i>
						<div class="item-inner"  style="float:left;margin-right:5px;">
							<div class="item-title" style="color:#000;">학원으로 배송</div>
						</div>
					</label>								
					<label class="radio col">
						<input type="radio" name="radio-addrType" value="user" v-model="radioAddrType">
						<i class="icon-radio" style="margin-right:2px;float:left"></i>
						<div class="item-inner"  style="float:left;margin-right:10px;">
							<div class="item-title" style="color:#000;">주소지로 배송</div>
						</div>
					</label>													
				</div>
				-->	
				<div class="actions-button actions-button-bold actions-label">
					<div class="actions-button-text">
						<button class="button button-fill" v-on:click="addBasKet();">
							장바구니 담기
						</button>				
					</div>
				</div>
				<div class="actions-button">
					<button class="button button-fill" v-on:click="finalPayment();">
					바로	결제하기
					</button>		
				</div>
			</div>
		</div>
	</div>  
</template>
<style lang="scss" scoped>

.thin-border-box {
	background-color: #fff;
	padding: 6px;
	margin: 4px;
}

.product-box {
	position:relative; 	
}

.amount-box {
	position:absolute;
	margin:3%;
	bottom:6%;
	right: 3%;	
	font-size: 0.87em;
	width: 100%;
	text-align: right;

}

.original-box {
	color: #699dc1;		
}
.discount-box {
	color: #fff;
	font-weight:bold;	
}

.top-box {
	& > p:nth-child(1) {
		margin:2px 0;
		text-align: center;

		& > i {
			font-size:10px;
		}

		& > span {
			font-size:10px;
		}
	}

	& > p:nth-child(2) {
		margin:2px 0;
		text-align: center;
		line-height: 0.8;

		& > span {
			font-size:30px;
			font-weight:600;
		}
	}

	& > p:nth-child(3) {
		margin:2px 0;
		text-align: center;

		& > span {
			font-size:10px;
		}
	}
}
</style>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {
			onlinePaymentList: [],
			radioAddrType:"company",
			selectItem: undefined,
			basketCnt: 0
		}
	},
	mounted() {
		const _this = this;
		_this.loadOnlinePaymentList();
	},
	methods: {

		getDate(dateValue) {
			const _this = this;			
			var returnDate = moment(dateValue).format("YYYY.MM.DD");		
		
			return returnDate;
		},
		goBasket() {
			const _this = this;

			PAGES.goPage(PAGES.MENU_PAYMENT_LIST);
		},
		getPrice(price) {
			const _this = this;
			var won = MODULE.Util.autoMakeComma(price);
			return won;
		},
		addItem(subItem) {
			const _this = this;
			_this.selectItem = subItem;
		},
		getProductImg(subItem) {
			const _this = this;			
			var imgPath = MODULE.Util.getProductImgUrl(subItem.PRODUCT_KEY);			

			return imgPath;

		},
		addBasKet() {
			const _this = this;

			if(	_this.selectItem == undefined){
				MODULE.DialogBox.message("선택된 상품이 없습니다.");
				return;
			}
			
			let requestInfo = {
				opType: "parent",
				childKey: _this.selectItem.STUDENT_KEY,
				productKey: _this.selectItem.PRODUCT_KEY,
				buyCnt: 1
			}

			API.jsonRequest({
				url: API.addPaymentBasketUrl(),
				data: requestInfo
			}).then(function (data) {
				
				MODULE.DialogBox.infoToast("장바구니에 추가 되었습니다.");
				_this.$f7.actions.close("#action-sheet-menu", true);		
				_this.getbasketCount();
				/*
				MODULE.DialogBox.okcancel(
					"확인","장바구니에 추가 되었습니다.\r\n결제 요청 목록으로 이동 할까요 ?",	
					function() {
						PAGES.goPage(PAGES.MENU_PAYMENT_LIST);
						_this.$f7.actions.close("#action-sheet-menu", true);							
					},function() {
						_this.$f7.actions.close("#action-sheet-menu", true);							
					}
				);
				*/

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		finalPayment() {
			const _this = this;
			var finalPaymentList = [];

			if(	_this.selectItem == undefined){
				MODULE.DialogBox.message("선택된 상품이 없습니다.");
				return;
			}
			
			var selectObjData = {
				BUY_CNT: 1,
				COMPANY_KEY: _this.selectItem.COMPANY_KEY,
				STUDENT_KEY: _this.selectItem.STUDENT_KEY,
				USER_NAME: _this.selectItem.USER_NAME,
				PRODUCT_KEY: _this.selectItem.PRODUCT_KEY,
				PRODUCT_TYPE: _this.selectItem.PRODUCT_TYPE,
				PRODUCT_NAME: _this.selectItem.PRODUCT_NAME,
				ORIGINAL_PRICE: _this.selectItem.ORIGINAL_PRICE,
				DISCOUNT_PRICE: _this.selectItem.DISCOUNT_PRICE								
			}

			finalPaymentList.push(selectObjData);

			var param = {
				paymentList : finalPaymentList,
				radioAddrType : _this.radioAddrType
			}

			PAGES.popPage(PAGES.SUB_PAYMENT_FINAL_LIST, param);
			_this.$f7.actions.close("#action-sheet-menu", true);							

		},
		getbasketCount() {
			const _this = this;
			var studentList = "";

			for(var i = 0; i < _this.onlinePaymentList.length; i++){
				 var studentKey = _this.onlinePaymentList[i].STUDENT_KEY;
				 
				 if(i > 0) {
					 studentList += ".";
				 }

				 studentList += studentKey;
			}

			let param = {
				pStudentList: studentList
			};

			API.ajaxRequest({	
				url: API.getBasketCountUrl(),
				data: param
			}).then(function (data) {
				_this.basketCnt = data.basketCnt;				
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
		},
		loadOnlinePaymentList() {
			const _this = this;

			let param = {};

			API.ajaxRequest({	
				url: API.getPaymentOnlineListUrl(),
				data: param
			}).then(function (data) {
				_this.basketCnt = data.basketCnt;
				_this.onlinePaymentList = data.onlinePaymentList;
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		}
	}
}
</script>